import { BilledSimTariff, Operator } from 'console/sim/types';
export function cleanMSISDN(msisdn) {
    if (msisdn == null) {
        throw 'Пусто';
    }
    const digits = msisdn.replace(/[^0-9]/g, '');
    switch (digits.length) {
        case 11:
        case 12:
            switch (digits.slice(0, 2)) {
                case '79':
                    return digits;
                case '89':
                    return digits.slice(1);
                default:
                    return digits;
            }
        case 10:
            if (digits[0] === '9') {
                return digits;
            }
            throw 'Некорректный номер: ' + digits;
        default:
            throw 'Введите номер телефона в формате +79ххххххххх';
    }
}
export function cleanICCID(iccid) {
    if (iccid == null) {
        throw 'Пусто';
    }
    const digits = iccid.replace(/[^0-9]/g, '');
    if (18 <= digits.length && digits.length <= 20) {
        return digits;
    }
    throw 'Номер SIM-карты должен быть от 18 до 20 цифр длиной';
}
export function getOperatorName(operator_code) {
    switch (operator_code) {
        case 'beeline':
        case 'beeline_jasper':
            return 'Билайн';
        case 'megafon':
            return 'Мегафон';
        case 'mts':
        case 'mts_zo':
        case 'mts_nn':
            return 'МТС (ZONT)';
        default:
            return operator_code;
    }
}
export function getSimTariffName(tariff, descriptions) {
    if (!tariff) {
        return '';
    }
    if (!descriptions) {
        return '???';
    }
    return descriptions.find(({ id }) => id == tariff)?.title ?? tariff;
}
/**
 * только для админки!
 * @param  operator_code код оператора
 * @return название для человека
 */
export function getCPOperatorName(operator_code) {
    switch (operator_code) {
        case 'Beeline':
        case 'beeline':
            return 'Билайн';
        case 'beeline_jasper':
            return 'Билайн Jasper';
        case 'MegaFon':
        case 'megafon':
            return 'Мегафон';
        case 'MTS':
        case 'mts':
            return 'МТС (МЛ)';
        case 'mts_zo':
            return 'МТС (мск)';
        case 'mts_nn':
            return 'МТС (нн)';
        default:
            return operator_code;
    }
}
export function isUpgradeTariff(oldTariff, newTariff) {
    if ((oldTariff == BilledSimTariff.BASE || oldTariff == BilledSimTariff.UNLIMITED) &&
        newTariff != oldTariff) {
        return true;
    }
    return false;
}
/**
 * Доступно ТОЛЬКО для сим-карт нижегородского МТС
 * @param {BilledSim} sim сим-карта
 */
export function isLegalUpgradeTariff(sim) {
    if (sim.sim_card.id.operator == Operator.mts_nn) {
        return true;
    }
    return false;
}
